import Request from "../helpers/Request";

export async function getTypeByName(name) {

    let result = [];

    await Request({
        path: `/product-type?q[name][like]=${name}`,
        method: 'GET',
        data: {},
        callback: response => {

            if (response) {

                result = response;
            }
        },
        headers: headers => {},
        error: error => {},
    });

    return result;
}